import React, { Component } from "react";
import ProductCostsChart from "./charts/product-costs";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../../../typeform/TypeformContent";

class ProductCosts extends Component {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    return data[team_id][key] || 0;
  };

  get productCosts() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      data.push({
        team: teams[team_id],
        value: this.getDataValue(team_id, "Average Unit Cost")
      });
    });

    return data;
  }

  get blockHeight() {
    const { teams } = this.props;
    const c = Object.keys(teams).length;
    const h = 152 + 34 * c;

    return h < 330 ? 330 : h;
  }

  get marginStyle() {
    const { teams } = this.props;
    const c = Object.keys(teams).length - 5;
    const c1 = c >= 0 ? c : 0;
    const c2 = 15 * c1;

    return {
      marginTop: c2 > 0 ? c2 : 15
    };
  }

  render() {
    return (
      <div className="col-md-3 col-xs-12">
        <div
          className="bg-white p-30 mh-330"
          style={{ height: this.blockHeight }}
        >
          <h5>
            PRODUCT COSTS
            <HelpIconButtonWithTooltipAndTypeformModal
              iconSize="sm"
              {...TypeformContent.PRODUCT_COSTS}
            />
          </h5>
          <hr></hr>
          <div className="mt-15" style={this.marginStyle}>
            <ProductCostsChart data={this.productCosts} />
          </div>
        </div>
      </div>
    );
  }
}

export default ProductCosts;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/product-costs.js